import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]卡片日历展示控制
 */
export function enableUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.postNoAuth('/gdlc/card/enable', req, config);
}

/**
 * [No Auth]根据tab获取产品列表
 */
export function getFundInTabUsingPOST(
  req: HighEndFinancialProductsDto | void,
  config?: RequestConfig
): Promise<ApiResultProducts4TabVo> {
  return resource.postNoAuth('/gdlc/fundInTab', req, config);
}

/**
 * [No Auth]精选产品二级页面产品列表
 */
export function getFundListUsingPOST(
  req: queryDto | void,
  config?: RequestConfig
): Promise<ApiResultProducts4SubpagePageVo> {
  return resource.postNoAuth('/gdlc/fundList', req, config);
}

/**
 * [No Auth]高端理财日历产品列表
 */
export function getFundList4calendarUsingPOST(
  req: queryDto4Calendar | void,
  config?: RequestConfig
): Promise<ApiResultListCalendarData4HEF> {
  return resource.postNoAuth('/gdlc/fundList4calendar', req, config);
}

/**
 * 查询高端产品交易日历
 */
export function getCalendarUsingPOST(req: FundTypoDto, config?: RequestConfig): Promise<ApiResultListSecuCalendarVo> {
  return resource.post('/gdlc/getCalendar', req, config);
}

/**
 * 私募资管根据产品code返回fundType
 */
export function getFundTypeUsingPOST(req: FundTypoDto, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.post('/gdlc/getFundType', req, config);
}

/**
 * 查询高端产品当天交易权限
 */
export function getJyqxUsingPOST(req: FundTypoDto, config?: RequestConfig): Promise<ApiResultJyqxVo> {
  return resource.post('/gdlc/getJyqx', req, config);
}

/**
 * 查看近两个月的日期是不是有产品推荐
 */
export function getRecommendDateUsingPOST(
  req: queryDto4RecommendDate | void,
  config?: RequestConfig
): Promise<ApiResultListstring> {
  return resource.post('/gdlc/getRecommendDate', req, config);
}

/**
 * 查看剩余可购买人数
 */
export function getRemainNumUsingPOST(
  req: RemainNumDto | void,
  config?: RequestConfig
): Promise<ApiResultListRemainNumVo> {
  return resource.post('/gdlc/getRemainNum', req, config);
}

/**
 * [No Auth]精选产品首页列表
 */
export function getTabFundListUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultModelInfo4HEF> {
  return resource.postNoAuth('/gdlc/tabFundList', req, config);
}

/**
 * [No Auth]精选产品tab列表
 */
export function getTabInfoListUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultListTabInfo4HEF> {
  return resource.postNoAuth('/gdlc/tabInfoList', req, config);
}
